import * as React from 'react';
import { Column } from "react-table";
import Table from "../../components/table/Table";
import { CLIENT_ROUTE, API_ROUTE, CLIENT_TITLE } from "./constants";
import TableIndicator from "../../components/common/TableStatus";
import dayjs from "dayjs";
import type { IBanner } from "./types";
import Page from "../../components/layout/Page";
import { useListPage } from "../../hooks";
import CreateButton from "../../components/common/CreateButton";
import RowActions from "../../components/table/RowActions";

interface IBannerRecord extends Pick<IBanner, '_id' | 'endDate' | 'startDate' | 'title' | 'isActive' | 'isDeleted' | 'order' | 'totalClickedCount' | 'createdAt'> {
    actions: unknown;
}

const BannerList = () => {

    const { records, paginationState, deleteRecord, handleInteraction } = useListPage({
        apiRoute: API_ROUTE,
        clientRoute: CLIENT_ROUTE
    })

    const columns: Column<IBannerRecord>[] =  [
        {
            Header: 'Нэр',
            accessor: 'title',
        },
        {
            Header: 'Хандалтын тоо',
            accessor: 'totalClickedCount',
        },
        {
            Header: 'Эхлэх огноо',
            accessor: 'startDate',
            Cell: (table) => {
                const value = table.row.original.startDate;
                const date = dayjs(value).format('YYYY-MM-DD')
                return (
                    <div>
                        {date}
                    </div>
                )
            }
        },
        {
            Header: 'Дуусах огноо',
            accessor: 'endDate',
            Cell: (table) => {
                const value = table.row.original.endDate;
                const date = dayjs(value).format('YYYY-MM-DD')
                return (
                    <div>
                        {date}
                    </div>
                )
            }
        },
        {
            Header: 'Дараалал',
            accessor: 'order',
        },
        {
            Header: 'Төлөв',
            accessor: 'isActive',
            Cell: ({ value }) => {
                return <TableIndicator active={value}/>;
            },
            width: 1
        },
        {
            Header: 'Үүссэн огноо',
            accessor: 'createdAt',
            Cell: ({ value }) => {
                return (
                    <div>
                        {dayjs(value).format('YYYY.MM.DD HH:mm')}
                    </div>
                );
            }
        },
        {
            Header: '',
            accessor: 'actions',
            Cell: (table) => {
                return (
                    <RowActions id={table.row.original._id} clientRoute={CLIENT_ROUTE} deleteRecord={deleteRecord}/>
                )
            }
        },
    ];

    return (
        <Page>
            <Page.Header title={CLIENT_TITLE}>
                <CreateButton route={CLIENT_ROUTE}/>
            </Page.Header>
            <Page.Body>
                <Table
                    searchable
                    columns={columns}
                    data={records}
                    totalPages={paginationState.totalPage}
                    onInteraction={handleInteraction}
                />
            </Page.Body>
        </Page>
    )
};

export default BannerList;